<script>
    let ekows = './assets/img/ekows.png';
</script>

<footer>
    <div class="container u-text-align_center">
        <a href="https://ekows.digital" target="_blank" rel="noreferrer"><img src={ekows} alt="Ekows-" /></a>
        <small>Made in the Metaverse.</small>
        <small>&copy; 2021-2022 ekows.eth</small>
    </div>
</footer>

<style type="text/scss">
    footer {
        background-color: var(--color-light);
        color: var(--color-dark);
        padding: 1rem 0;

        a {
            border-bottom: none;
        }

        img {
            border: 2px solid var(--color-highlight);
            border-radius: 50%;
            margin-bottom: 0.5rem;
            width: 40px; height: 40px;
        }

        small {
            display: block;
        }
    }
</style>